import { Auth, Cache } from 'aws-amplify';
import jwtDecode from 'jwt-decode';
import { SHA256 } from 'crypto-js';
import appSyncClient from '../../appsync/client';
import GetUserInfoQuery from '../../appsync/queries/GetUser';

const getCurrentUser = async () => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    return user;
  } catch (error) {
    console.warn(error, '... attempting to fetch guest user info'); // eslint-disable-line no-console
  }

  const guestUserData = await appSyncClient.query({ query: GetUserInfoQuery });
  return guestUserData.data.user;
};

export const getCurrentUserId = async () => {
  const user = await getCurrentUser();
  return user.id || user.username;
};

export const getSocialToken = async () => {
  const result = await Cache.getItem('federatedInfo');
  if (!result) return null;
  return result.token;
};

export const getCurrentUserEmail = async () => {
  const user = await getCurrentUser();
  if (user.attributes) return user.attributes.email;
  if (user.email) return user.email;
  const socialToken = await getSocialToken();
  const token = jwtDecode(socialToken);
  return token.email;
};

export const getUserFromToken = (socialToken) => {
  const token = jwtDecode(socialToken);
  return {
    name: token.name,
    email: token.email,
  };
};

export const getCurrentUserHashedEmail = async () => {
  const userEmail = await getCurrentUserEmail();
  const hashedUserEmail = SHA256(userEmail).toString();
  return hashedUserEmail;
};

export const changePassword = async (oldPassword, newPassword) => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    return Auth.changePassword(user, oldPassword, newPassword);
  } catch (error) {
    console.error('Unable to change password: ', error); // eslint-disable-line no-console
    throw error;
  }
};
